// components/schema/ValidationToast.jsx

import React from "react"

export default function ValidationToast({ validToast }) {
  if (!validToast) return null
  return (
    <div
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-md border shadow
        ${validToast.ok
          ? "bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-900/40 dark:text-emerald-200 dark:border-emerald-800"
          : "bg-red-50 text-red-800 border-red-200 dark:bg-red-900/40 dark:text-red-200 dark:border-red-800"}`}
    >
      {validToast.msg}
    </div>
  )
}
